export const DEFAULT_COURIERS = [
    { name: 'Lala Move', slug: 'lalamove' },
    { name: '3rd Party-Delivery', slug: 'third_party_delivery' },
    { name: 'Self-Delivery', slug: 'self_delivery' },
    { name: 'Self-Collection', slug: 'self_collection' },
];

export const couriersForMethod = (method, currentValue = '') => {
    const source = method?.couriers?.length ? method.couriers : DEFAULT_COURIERS;
    const rows = source.map((courier) => ({
        value: courier.slug || courier.value || '',
        label: courier.name || courier.label || '',
    })).filter((row) => row.value || row.label);

    if (currentValue && !rows.some((row) => row.value === currentValue || row.label === currentValue)) {
        rows.push({ value: currentValue, label: currentValue });
    }

    return rows;
};

export const courierLabel = (value, methods = [], fallbackMap = {}) => {
    if (!value) {
        return '';
    }

    for (const method of methods || []) {
        for (const courier of method?.couriers || []) {
            if (courier.slug === value || courier.name === value) {
                return courier.name || value;
            }
        }
    }

    return fallbackMap?.[value] || value;
};
